module.exports = __webpack_public_path__ + "img/sougou.41e6a7b7.jpg";